import * as React from 'react';
import { OneWaySlider } from '../../range-slider/OneWaySlider';

const styles = require('./RadiusFilter.module.scss');

type RadiusFilterProps = {
    isVisible: boolean;
    defaultValue: number;
    onChange: (value: number) => void;
    value?: number;
};

export const RadiusFilter: React.FC<RadiusFilterProps> = ({ onChange, defaultValue = 0, value }) => {
    return (
        <div className={styles.sliderContainer}>
            <OneWaySlider formikName='radius' onChange={onChange} defaultValue={defaultValue} value={value} min={0} max={60} step={5} />
        </div>
    );
};
